import request from '@/utils/request'

export function getShopSmsList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopSms.listShopSms',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取店铺短信明细列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function listShopSmsDetail(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopSms.listShopSmsDetail',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}


export function listAShopSms(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopSms.listAShopSms',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function updateAShopSms(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopSms.updateAShopSms',
      method: 'post',
      data: params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function updateShopSmsSwitch(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopSms.updateShopSmsSwitch',
      method: 'post',
      data: params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
